import Logs from './logs';

export default Logs;
